import { useEffect } from "react";

export default function useJsScript(url: string) {
  const scriptId = `js-script-${url
    .replace(/[^a-zA-Z0-9]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")}`;

  useEffect(() => {
    if (!url) return;

    const existingScript = document.getElementById(scriptId);

    if (existingScript) return;

    const script = document.createElement("script");

    script.src = url;
    script.id = scriptId;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
}
